<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header"><i class="fa fa-dollarsign"></i> Árak</h1>
				<Loading v-if="!guesthouses"></Loading>
				<div v-else>
					<v-select v-model="guesthouse_id" :options="guesthouses" :reduce="(option) => option.id"
						label="name" class="form-control" style="min-width:300px;">
						<template #search="{ attributes, events }">
							<input class="vs__search" :required="guesthouse_id" v-bind="attributes" v-on="events" />
						</template>
					</v-select>
				</div>
			</div>
			<div class="ms-auto">
				<help iconClass="fa-2x" helpId="priceHelp" title="Árak szerkesztése"
					text="Az árváltoztatásokat csak a mentés gomb megnyomásával menti a rendszer"></help>
			</div>
		</div>
		<Loading v-if="!prices && !apartment_prices"></Loading>

		<div v-else>
			<div class="row" v-if="apartment_prices">
				<div class="col-md-6">
					<panel title="Apartman árak">
						<form @submit.prevent="addApartmentPrice()" class="row row-cols-lg-auto g-3 align-items-center">
							<div class="col-12">
								<input type="number" v-model="apartment_price_to_add.member_value" class="form-control"
									placeholder="Ár tagoknak">
								<div class="invalid-feedback d-block" v-if="errors.member_value">
									{{ errors.member_value[0] }}
								</div>
							</div>
							<div class="col-12">
								<input type="number" v-model="apartment_price_to_add.non_member_value"
									class="form-control" placeholder="Ár nem tagoknak">
								<div class="invalid-feedback d-block" v-if="errors.non_member_value">
									{{ errors.non_member_value[0] }}
								</div>
							</div>
							<div class="col-12">
								<input type="date" v-model="apartment_price_to_add.valid_from" class="form-control"
									placeholder="érvényes ettől">
								<div class="invalid-feedback d-block" v-if="errors.valid_from">
									{{ errors.valid_from[0] }}
								</div>
							</div>
							<div class="col-12">
								<button class="btn btn-success"><i class="fa fa-plus me-1"></i> Hozzáadás</button>
							</div>
						</form>
						<NoRecords v-if="getApartmentPrices().length == 0" main_icon="fa fa-dollar-sign"
							title="Nem találhatóak árak"></NoRecords>
						<table class="table" v-else>
							<thead>
								<tr>
									<th>Ár tagoknak</th>
									<th>Ár nem tagoknak</th>
									<th>Érvényesség kezdete</th>
									<th>Érvényesség vége</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(price, p_id) in getApartmentPrices()" :key="p_id">
									<td class="align-middle">
										<input type="text" v-if="isNewPrice(price.created_at)" :value="price.member_value" @blur="savePrice(price.id,$event.target,'member_value')" />
										<span v-else>{{ price.member_value.toLocaleString('hu-HU') }} Ft</span>
									</td>
									
									<td class="align-middle">
										<input type="text" v-if="isNewPrice(price.created_at)" :value="price.non_member_value" @blur="savePrice(price.id,$event.target,'non_member_value')" />
										<span v-else>{{ price.non_member_value.toLocaleString('hu-HU') }} Ft</span>
									</td>
									<td class="align-middle">{{ price.valid_from }}</td>
									<td class="align-middle">{{ p_id == 0 ? 'Visszavonásig' :
					getApartmentPrices()[p_id - 1].valid_from }}</td>
								</tr>
							</tbody>
						</table>
					</panel>
				</div>
			</div>
			<div class="row" v-else-if="prices">
				<div class="col-md-6" v-for="(guest_category, id) in guest_categories" :key="id">
					<panel :title="guest_category.name + ' árak'">
						<form @submit.prevent="addPrice(guest_category.price_to_add)"
							class="row row-cols-lg-auto g-3 align-items-center">
							<div class="col-12">
								<input type="number" v-model="guest_category.price_to_add.value" class="form-control"
									placeholder="Ár">
								<div class="invalid-feedback d-block" v-if="errors.value">
									{{ errors.value[0] }}
								</div>
							</div>
							<div class="col-12">
								<input type="date" v-model="guest_category.price_to_add.valid_from" class="form-control"
									placeholder="érvényes ettől">
								<div class="invalid-feedback d-block" v-if="errors.valid_from">
									{{ errors.valid_from[0] }}
								</div>
							</div>
							<div class="col-12">
								<button class="btn btn-success"><i class="fa fa-plus me-1"></i> Hozzáadás</button>
							</div>
						</form>
						<hr />
						<NoRecords v-if="getPrices(guest_category.id).length == 0" main_icon="fa fa-dollar-sign"
							title="Nem találhatóak árak"></NoRecords>
						<table class="table" v-else>
							<thead>
								<tr>
									<th>Ár</th>
									<th>Érvényesség kezdete</th>
									<th>Érvényesség vége</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(price, p_id) in getPrices(guest_category.id)" :key="p_id">
									<td class="align-middle">
										<input type="text" v-if="isNewPrice(price.created_at)" :value="price.value" @blur="savePrice(price.id,$event.target,'value')" />
										<span v-else>{{ price.value.toLocaleString('hu-HU') }} Ft</span>
									</td>
									<td class="align-middle">{{ price.valid_from }}</td>
									<td class="align-middle">{{ p_id == 0 ? 'Visszavonásig' :
					getPrices(guest_category.id)[p_id - 1].valid_from }}</td>
								</tr>
							</tbody>
						</table>
					</panel>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Price from '../../apis/Price';
import ApartmentPrice from '../../apis/ApartmentPrice';
import Setting from '../../apis/Setting';
import Guesthouse from '../../apis/Guesthouse';

export default {
	name: 'Price',
	data() {
		return {
			guesthouses: null,
			guesthouse_id: 1,
			prices: null,
			apartment_prices: null,
			guest_categories: null,
			apartment_price_to_add: {},
			errors: []
		}
	},
	created() {
		Guesthouse.index().then(response => {
			this.guesthouses = response.data;
		}).then(() => {

			this.getGuesthousePrices();
		});

		Setting.guestCategories()
			.then(response => {
				this.guest_categories = response.data;
				this.guest_categories.forEach(g => {
					g.price_to_add = { guest_category_id: g.id };
				});
			}).catch(() => {
				this.guest_categories = []
			});

	},
	watch: {
		guesthouse_id: function () {
			this.getGuesthousePrices();
		}
	},
	methods: {
		getGuesthousePrices() {
			let selected_guesthouse = this.guesthouses.filter(obj => obj.id == this.guesthouse_id)[0];
			this.prices = null;
			this.apartment_prices = null;

			if (selected_guesthouse.apartment) {
				ApartmentPrice.index().then(response => {
					this.apartment_prices = response.data;
				}).catch(() => {
					this.apartment_prices = [];
				});
			}
			else {
				Price.indexGuesthouse(this.guesthouse_id).then(response => {
					this.prices = response.data;
				}).catch(() => {
					this.prices = [];
				});
			}
		},
		getPrices(guest_category_id) {
			return this.prices.filter(p => p.guest_category_id == guest_category_id).sort((a, b) => new Date(b.valid_from) - new Date(a.valid_from));
		},
		getApartmentPrices() {
			return this.apartment_prices.filter(p => p.id).sort((a, b) => new Date(b.valid_from) - new Date(a.valid_from));
		},
		addPrice(price) {
			price.guesthouse_id = this.guesthouse_id;
			Price.store(price)
				.then(response => {
					this.prices.push(response.data);
				}).catch(error => {
					if (error.response.data.errors) {
						this.errors = error.response.data.errors;
					}
				})
		},
		addApartmentPrice() {
			ApartmentPrice.store(this.apartment_price_to_add)
				.then(response => {
					this.apartment_prices.push(response.data);
				}).catch(error => {
					if (error.response.data.errors) {
						this.errors = error.response.data.errors;
					}
				})
		},
		isNewPrice(createdAt){
            const now = new Date();
            const fifteenMinutesAgo = new Date(now.getTime() - 15 * 60 * 1000); // 15 minutes ago

            const createdAtDate = new Date(createdAt);
            return createdAtDate >= fifteenMinutesAgo;
        },
		savePrice(id,input,mode){
			Price.update({id: id, value: input.value, mode: mode});
		}
	}
};
</script>